import { extract, isNotEmptyArray } from '@vy/utils';
import React from 'react';
import type { FieldPath } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { ErrorNotification } from '../../../../../components/design/ErrorNotification/ErrorNotification';
import { useErrorNotificationAdapter } from '../../../../../components/design/ErrorNotification/hooks/use-error-notification-adapter';
import { useFormErrorNotificationContext } from '../../../../../contexts/form-error-notification-context/form-error-notification-context';
import type { CreateCreditNoteFormValues } from '../CreateCreditNoteForm/CreateCreditNoteForm';

const CREDIT_NOTE_ERROR_NOTIFICATION_DELAY_FOCUS = 100;

export const CreateCreditNoteErrorNotification: React.FC = () => {
  const { errorsFields, showErrorNotification, setShowErrorNotification } =
    useFormErrorNotificationContext<CreateCreditNoteFormValues>();
  const {
    formState: { errors },
    setFocus,
  } = useFormContext<CreateCreditNoteFormValues>();

  const mappedErrors = useErrorNotificationAdapter(extract(errorsFields, 'fieldPath'), errors);

  return (
    <ErrorNotification
      open={showErrorNotification && isNotEmptyArray(mappedErrors)}
      errors={mappedErrors}
      description="Find and fix the errors before saving the credit note"
      onGoTo={(fieldPath) => {
        delayFocus(fieldPath as FieldPath<CreateCreditNoteFormValues>, setFocus);
      }}
      onClose={() => setShowErrorNotification(false)}
    />
  );
};

function delayFocus(
  fieldPath: FieldPath<CreateCreditNoteFormValues>,
  setFocus: (fieldPath: FieldPath<CreateCreditNoteFormValues>) => void,
) {
  setTimeout(() => {
    setFocus(fieldPath);
  }, CREDIT_NOTE_ERROR_NOTIFICATION_DELAY_FOCUS);
}
